import { Helmet } from 'react-helmet-async'

import useAuth from 'contexts/auth'

const TITLE_SEPARATOR = ' · '

function useConsoleAppTitle(title?: string) {
  const { self } = useAuth()
  const name = self?.workspace?.name

  const devPrefix = import.meta.env.DEV ? '[DEV]' : ''
  const titles = [title, name, 'Integration Console'].filter(Boolean)

  return `${devPrefix} ${titles.join(TITLE_SEPARATOR)}`.trim()
}

export function HeadTitle({ children }: { children?: string | string[] }) {
  const title = useConsoleAppTitle(typeof children === 'string' ? children : children?.join(''))
  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  )
}
